import { createVNode as o, mergeProps as e } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SwitchHospitalFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (r, a) => {
  const i = {
    ...r,
    ...a.attrs
  };
  return o(d, e(i, {
    icon: l
  }), null);
};
t.displayName = "SwitchHospitalFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
